(function () {

  /* ── Quick Add to Cart ── */
  window.collQuickAdd = function (event, variantId) {
    event.preventDefault();
    event.stopPropagation();

    var btn = event.currentTarget;
    if (btn.disabled) return;

    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    })
    .then(function () {
      btn.textContent = '✓ Added!';
      if (window.Shopify && typeof Shopify.getCart === 'function') {
        Shopify.getCart(function (cart) {
          Shopify.updateQuickCart(cart);
          Shopify.afterCartUpdate(cart);
          Shopify.showModal();
        });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      btn.textContent = orig;
      btn.disabled = false;
    });
  };

  /* ── Sort-by select ──
     Preserves all active filter params (filter.*) when changing sort.
     URLSearchParams handles encoding — no manual encodeURIComponent needed.
  ── */
  function initSort() {
    var sel = document.getElementById('sortBy');
    if (!sel) return;

    var cur = sel.getAttribute('data-sort');
    if (cur) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === cur) { sel.selectedIndex = i; break; }
      }
    }

    sel.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      params.delete('page'); /* Reset to page 1 on sort change */
      window.location = window.location.pathname + '?' + params.toString();
    });
  }

  /* ── Persist query params through pagination ──
     Shopify OS 1.0: paginate.*.url only generates ?page=N and does NOT carry
     forward Search & Discovery filter params (filter.*) or sort_by.
     This patches all pagination links after page load so active filters and
     sort order survive page navigation.
  ── */
  function persistQueryParams() {
    var params = new URLSearchParams(window.location.search);

    /* Collect everything except 'page' — pagination link already has its own page value */
    var toPreserve = new URLSearchParams();
    params.forEach(function (value, key) {
      if (key !== 'page') toPreserve.append(key, value);
    });

    if (!toPreserve.toString()) return;

    document.querySelectorAll('.coll-pagination a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;

      /* Extract the page number from the pagination link */
      var pageMatch = href.match(/[?&]page=(\d+)/);
      var pageNum   = pageMatch ? pageMatch[1] : null;

      /* Rebuild: all preserved params + the link's own page number */
      var newParams = new URLSearchParams(toPreserve.toString());
      if (pageNum) newParams.set('page', pageNum);

      var basePath = href.split('?')[0];
      link.setAttribute('href', basePath + '?' + newParams.toString());
    });
  }

  function init() {
    initSort();
    persistQueryParams();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
